/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'icomoo/330-sort-alpha-desc': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M5 12V0H3v12H.5L4 15.5 7.5 12H5zM14.5 7h-4a.5.5 0 01-.416-.777L13.566 1H10.5a.5.5 0 010-1h4a.502.502 0 01.416.777L11.434 6H14.5a.5.5 0 010 1zM15.947 15.276l-3-6a.5.5 0 00-.894 0l-3 6a.5.5 0 00.895.447l.862-1.724h3.382l.862 1.724a.5.5 0 00.895-.447zM11.309 13l1.191-2.382L13.691 13h-2.382z"/>'
  }
})
